/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/layout'

const boardsRouter = {
    path: '/boards',
    component: Layout,
    redirect: 'noRedirect',
    name: 'Boards',
    meta: {
        title: '看板',
        icon: 'el-icon-data-analysis'
    },
    children: [
        {
            path: 'tvs',
            component: () => import('@/views/boards/TV'),
            name: 'TV',
            meta: { title: '大屏列表', noCache: true }
        },
        {
            path: 'list',
            component: () => import('@/views/boards/list'),
            name: 'Board',
            meta: { title: '看板列表', noCache: true }
        }, {
            path: 'datasource',
            component: () => import('@/views/boards/datasource'),
            name: 'BoardDataSource',
            meta: { title: '数据源', noCache: true }
        }, {
            path: 'design',
            component: () => import('@/views/boards/design'),
            name: 'Board',
            meta: { title: '看板设计', noCache: true },
            hidden: true
        }
    ]
}

export default boardsRouter
